import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '@app/auth/services/auth.service';
import { SessionStorageService } from '@app/shared/services/storage';
import { Block } from '@core/models/block/block.model';
import { ButtonHandlerService } from '@core/services/button-handler.service';

import { SubSink } from '@core/utils/subsink';

import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';

import { of } from 'rxjs';
import { catchError, exhaustMap, filter } from 'rxjs/operators';

@Component({
  selector: 'app-login-form',
  template: `
    <form [formGroup]="formGroup">
      <div app-block-container [children]="specialBlock.children"></div>
    </form>
  `,
  providers: [FormService],
  standalone: false,
})
export class LoginFormComponent implements OnInit, OnDestroy {
  @Input() specialBlock: Block;
  formGroup = this.formService.formGroup;
  private subSink = new SubSink();

  constructor(private _router: Router,
              private _route: ActivatedRoute,
              private as: AuthService,
              private formService: FormService,
              private storageService: SessionStorageService,
              private buttonHandlerService: ButtonHandlerService) {
  }


  ngOnInit(): void {
    const locale = this.storageService.getItem('language');
    this.subSink.sink =
      this.buttonHandlerService.click$
        .pipe(
          exhaustMap(({actionData: {path}}) =>
            this.as.login(path, this.formGroup.getRawValue()).pipe(
              catchError(({ok, error}) => {
                this.formService.setFormErrors(error.errors);
                return of(ok);
              }),
            ),
          ),
          filter((result: boolean | object) => !!result),
        )
        .subscribe(() => {
          const returnUrl = this._route.snapshot.queryParams['returnUrl'];
          this._router.navigate([returnUrl ?? `/${locale}/account`]);
        });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
